export const CONTRAST1 = 'CONTRAST1'
export const CONTRAST2 = 'CONTRAST2'
